!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.highlightLib = t() : e.highlightLib = t();
}(this, function () {
  return function (e) {
    var t = {};

    function n(i) {
      if (t[i]) return t[i].exports;
      var o = t[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return e[i].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, i) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(i, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return i;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 1);
  }([function (e) {
    e.exports = JSON.parse('{"name":"highlight.run","version":"2.5.0","scripts":{"build":"webpack --mode=production --config=./webpack.config.js","dev":"doppler run -- webpack-dev-server --progress --colors --watch","lint":"prettier --check --write \'src/**/*.{ts,tsx,scss}\'","analyze":"webpack --mode=production --config=./webpack.config.js --json --profile > dist/firstload/src/stats.json && yarn webpack-bundle-analyzer dist/firstload/src/stats.json","test":"jest --detectOpenHandles"},"main":"dist/firstload/src/index.js","types":"dist/firstload/src/index.d.ts","devDependencies":{"@babel/preset-env":"^7.14.7","@babel/preset-typescript":"^7.14.5","@types/chrome":"^0.0.144","@types/jest":"^26.0.24","jest":"^27.0.6","jest-fail-on-console":"^2.0.4","prettier":"^2.2.1","ts-loader":"^8.0.4","typescript":"^4.0.3","webpack":"^4.44.1","webpack-bundle-analyzer":"^4.4.2","webpack-cli":"^3.3.12","webpack-dev-server":"^3.11.0"},"dependencies":{},"setupFiles":["./tests/jest.overrides.js"]}');
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "H", function () {
      return d;
    });

    var i,
        o,
        r,
        s,
        a = n(0),
        l = "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js",
        _c = function c() {
      return (_c = Object.assign || function (e) {
        for (var t, n = 1, i = arguments.length; n < i; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        u = function u(e, t) {
      console.warn("Highlight Warning: (" + e + "): ", t);
    },
        d = {
      options: void 0,
      init: function init(e, t) {
        var n, r, s, c;

        try {
          if (d.options = t, "undefined" == typeof window || "undefined" == typeof document) return;
          i = document.createElement("script");
          var p = (null == t ? void 0 : t.scriptUrl) ? t.scriptUrl : "https://static.highlight.run/index.js";
          i.setAttribute("src", p + "?" + new Date().getMilliseconds()), i.setAttribute("type", "text/javascript"), document.getElementsByTagName("head")[0].appendChild(i), i.addEventListener("load", function () {
            o = new window.Highlight({
              organizationID: e,
              debug: null == t ? void 0 : t.debug,
              backendUrl: null == t ? void 0 : t.backendUrl,
              disableNetworkRecording: null == t ? void 0 : t.disableNetworkRecording,
              networkRecording: null == t ? void 0 : t.networkRecording,
              disableConsoleRecording: null == t ? void 0 : t.disableConsoleRecording,
              enableSegmentIntegration: null == t ? void 0 : t.enableSegmentIntegration,
              enableStrictPrivacy: (null == t ? void 0 : t.enableStrictPrivacy) || !1,
              firstloadVersion: a.version,
              environment: (null == t ? void 0 : t.environment) || "production",
              appVersion: null == t ? void 0 : t.version
            }), (null == t ? void 0 : t.manualStart) || o.initialize(e);
          }), (null === (r = null === (n = null == t ? void 0 : t.integrations) || void 0 === n ? void 0 : n.mixpanel) || void 0 === r ? void 0 : r.projectToken) && function (e) {
            var t,
                n,
                i,
                o = e.projectToken;
            document, (t = window.mixpanel || []).__SV || (window.mixpanel = t, t._i = [], t.init = function (e, o, r) {
              function s(e, t) {
                var n = t.split(".");
                2 == n.length && (e = e[n[0]], t = n[1]), e[t] = function () {
                  e.push([t].concat(Array.prototype.slice.call(arguments, 0)));
                };
              }

              var a = t;

              for (void 0 !== r ? a = t[r] = [] : r = "mixpanel", a.people = a.people || [], a.toString = function (e) {
                var t = "mixpanel";
                return "mixpanel" !== r && (t += "." + r), e || (t += " (stub)"), t;
              }, a.people.toString = function () {
                return a.toString(1) + ".people (stub)";
              }, n = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" "), i = 0; i < n.length; i++) {
                s(a, n[i]);
              }

              var l = "set set_once union unset remove delete".split(" ");
              a.get_group = function () {
                function e(e) {
                  t[e] = function () {
                    call2_args = arguments, call2 = [e].concat(Array.prototype.slice.call(call2_args, 0)), a.push([n, call2]);
                  };
                }

                for (var t = {}, n = ["get_group"].concat(Array.prototype.slice.call(arguments, 0)), i = 0; i < l.length; i++) {
                  e(l[i]);
                }

                return t;
              }, t._i.push([e, o, r]);
            }, t.__SV = 1.2);
            var r = document.createElement("script");
            r.src = l, document.head.appendChild(r), r.addEventListener("load", function () {
              var e;
              null === (e = window.mixpanel) || void 0 === e || e.init(o);
            });
          }(t.integrations.mixpanel), (null === (c = null === (s = null == t ? void 0 : t.integrations) || void 0 === s ? void 0 : s.amplitude) || void 0 === c ? void 0 : c.apiKey) && function (e) {
            var t = e.apiKey;
            !function (e, n) {
              var i = e.amplitude || {
                _q: [],
                _iq: {}
              },
                  o = n.createElement("script");
              o.type = "text/javascript", o.integrity = "sha384-u0hlTAJ1tNefeBKwiBNwB4CkHZ1ck4ajx/pKmwWtc+IufKJiCQZ+WjJIi+7C6Ntm", o.crossOrigin = "anonymous", o.async = !0, o.src = "https://cdn.amplitude.com/libs/amplitude-8.1.0-min.gz.js", o.onload = function () {
                e.amplitude.runQueuedFunctions || console.log("[Amplitude] Error: could not load SDK"), amplitude.getInstance().init(t);
              };
              var r = n.getElementsByTagName("script")[0];

              function s(e, t) {
                e.prototype[t] = function () {
                  return this._q.push([t].concat(Array.prototype.slice.call(arguments, 0))), this;
                };
              }

              r.parentNode.insertBefore(o, r);

              for (var a = function a() {
                return this._q = [], this;
              }, l = ["add", "append", "clearAll", "prepend", "set", "setOnce", "unset", "preInsert", "postInsert", "remove"], c = 0; c < l.length; c++) {
                s(a, l[c]);
              }

              i.Identify = a;

              for (var u = function u() {
                return this._q = [], this;
              }, d = ["setProductId", "setQuantity", "setPrice", "setRevenueType", "setEventProperties"], p = 0; p < d.length; p++) {
                s(u, d[p]);
              }

              i.Revenue = u;
              var g = ["init", "logEvent", "logRevenue", "setUserId", "setUserProperties", "setOptOut", "setVersionName", "setDomain", "setDeviceId", "enableTracking", "setGlobalUserProperties", "identify", "clearUserProperties", "setGroup", "logRevenueV2", "regenerateDeviceId", "groupIdentify", "onInit", "logEventWithTimestamp", "logEventWithGroups", "setSessionId", "resetSessionId"];

              function f(e) {
                function t(t) {
                  e[t] = function () {
                    e._q.push([t].concat(Array.prototype.slice.call(arguments, 0)));
                  };
                }

                for (var n = 0; n < g.length; n++) {
                  t(g[n]);
                }
              }

              f(i), i.getInstance = function (e) {
                return e = (e && 0 !== e.length ? e : "$default_instance").toLowerCase(), Object.prototype.hasOwnProperty.call(i._iq, e) || (i._iq[e] = {
                  _q: []
                }, f(i._iq[e])), i._iq[e];
              }, e.amplitude = i;
            }(window, document);
          }(t.integrations.amplitude);
        } catch (e) {
          u("init", e);
        }
      },
      consumeError: function consumeError(e, t, n) {
        try {
          d.onHighlightReady(function () {
            return o.consumeCustomError(e, t, JSON.stringify(n));
          });
        } catch (e) {
          u("error", e);
        }
      },
      error: function error(e, t) {
        try {
          d.onHighlightReady(function () {
            return o.pushCustomError(e, JSON.stringify(t));
          });
        } catch (e) {
          u("error", e);
        }
      },
      track: function track(e, t) {
        var n, i;
        void 0 === t && (t = {});

        try {
          d.onHighlightReady(function () {
            return o.addProperties(_c(_c({}, t), {
              event: e
            }));
          });
          var r = null == o ? void 0 : o.sessionData.sessionID,
              s = void 0;
          r && (s = "https://app.highlight.run/sessions/" + r), (null === (n = window.mixpanel) || void 0 === n ? void 0 : n.track) && window.mixpanel.track(e, _c(_c({}, t), {
            highlightSessionURL: s
          })), (null === (i = window.amplitude) || void 0 === i ? void 0 : i.getInstance) && window.amplitude.getInstance().logEvent(e, _c(_c({}, t), {
            highlightSessionURL: s
          }));
        } catch (e) {
          u("track", e);
        }
      },
      start: function start() {
        var e;

        try {
          if ("Recording" === (null == o ? void 0 : o.state)) return void console.warn("You cannot called `start()` again. The session is already being recorded.");
          if (null === (e = d.options) || void 0 === e ? void 0 : e.manualStart) var t = setInterval(function () {
            o && (clearInterval(t), o.initialize());
          }, 200);else console.warn("Highlight Error: Can't call `start()` without setting `manualStart` option in `H.init`");
        } catch (e) {
          u("start", e);
        }
      },
      stop: function stop() {
        try {
          d.onHighlightReady(function () {
            return o.stopRecording(!0);
          });
        } catch (e) {
          u("stop", e);
        }
      },
      identify: function identify(e, t) {
        var n, i;
        void 0 === t && (t = {});

        try {
          d.onHighlightReady(function () {
            return o.identify(e, t);
          });
        } catch (e) {
          u("identify", e);
        }

        if ((null === (n = window.mixpanel) || void 0 === n ? void 0 : n.identify) && window.mixpanel.identify(e), (null === (i = window.amplitude) || void 0 === i ? void 0 : i.getInstance) && (window.amplitude.getInstance().setUserId(e), Object.keys(t).length > 0)) {
          var r = Object.keys(t).reduce(function (e, n) {
            return e.set(n, t[n]), e;
          }, new window.amplitude.Identify());
          window.amplitude.getInstance().identify(r);
        }
      },
      getSessionURL: function getSessionURL() {
        return new Promise(function (e, t) {
          d.onHighlightReady(function () {
            var n = o.organizationID,
                i = o.sessionData.sessionID;
            n && i ? e("app.highlight.run/" + n + "/sessions/" + i) : t(new Error("org ID or session ID is empty"));
          });
        });
      },
      getSessionDetails: function getSessionDetails() {
        return new Promise(function (e, t) {
          d.onHighlightReady(function () {
            var n = o.organizationID,
                i = o.sessionData.sessionID;

            if (n && i) {
              var r = o.getCurrentSessionTimestamp(),
                  s = new Date().getTime(),
                  a = "https://app.highlight.run/" + n + "/sessions/" + i,
                  l = new URL(a),
                  c = new URL(a);
              c.searchParams.set("ts", ((s - r) / 1e3).toString()), e({
                url: l.toString(),
                urlWithTimestamp: c.toString()
              });
            } else t(new Error("org ID or session ID is empty"));
          });
        });
      },
      onHighlightReady: function onHighlightReady(e) {
        try {
          if (o && o.ready) e();else var t = setInterval(function () {
            o && o.ready && (clearInterval(t), e());
          }, 200);
        } catch (e) {
          u("onHighlightReady", e);
        }
      }
    };

    "undefined" != typeof window && (window.H = d), "undefined" != typeof chrome && (null === (r = null === chrome || void 0 === chrome ? void 0 : chrome.runtime) || void 0 === r ? void 0 : r.onMessage) && (null === (s = null === chrome || void 0 === chrome ? void 0 : chrome.runtime) || void 0 === s || s.onMessage.addListener(function (e, t, n) {
      var i = e.action;

      switch (console.log("[highlight] received '" + i + "' event from extension."), i) {
        case "init":
          var o = "http://localhost:8080/dist/index.js";
          console.log("url", o), d.init(1, {
            debug: !0,
            scriptUrl: o
          }), d.getSessionURL().then(function (e) {
            n({
              url: e
            });
          });
          break;

        case "stop":
          d.stop(), n({
            success: !0
          });
      }

      return !0;
    }));
  }]);
});